<div
  snDrawerAppContent
  class="selection-bar--container"
  [@snSlideInUp]
  [@snSlideOutUp]
  *ngIf="selection.hasValue()"
>
  <sn-icon-button class="selection-bar__clear-button" (click)="deselectAll()">
    <sn-icon>clear</sn-icon>
  </sn-icon-button>

  <h3 class="selection-bar__title">
    {{ 'common.itemsSelected' | t : { count: selection.selected.length } }}
  </h3>

  <sn-action-list class="selection-bar__actions" [items]="actions"></sn-action-list>
</div>
